<template>
    <router-view></router-view>
</template>

<script>

export default {
  name: 'emptyView',
  data() {
    return {};
  },
  computed: {
  },
  methods: {}
};
</script>
